import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverable?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick,
  hoverable = false,
}) => {
  return (
    <motion.div
      onClick={onClick}
      className={`bg-surface rounded-large p-32 shadow-sm ${
        hoverable ? 'cursor-pointer' : ''
      } ${className}`}
      whileHover={
        hoverable
          ? {
              y: -4,
              boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
            }
          : {}
      }
      transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default Card;
